const icons = {
  weight: 'scale', bodyFat: 'water', sleep: 'sleeping-in-bed', energy: 'fire-element',
  settings: 'settings', workout: 'dumbbell', calendar: 'calendar', clock: 'clock',
  sync: 'cloud', heart: 'hearts', flower: 'flower', bear: 'teddy-bear',
} as const

export type CuteIconName = keyof typeof icons

/** Decorative Icons8 Cute Color assets, bundled locally for offline use. */
export function CuteIcon({ name, size = 28 }: { name: CuteIconName; size?: number }) {
  return <img className="cute-icon" src={`/icons/cute-color/${icons[name]}.png`} alt="" aria-hidden="true" width={size} height={size} draggable={false} />
}
